import { render, staticRenderFns } from "./DeleteCurve.vue?vue&type=template&id=912c6d68"
import script from "./DeleteCurve.vue?vue&type=script&lang=ts"
export * from "./DeleteCurve.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports